import { render, staticRenderFns } from "./qualityDetail.vue?vue&type=template&id=67271583&scoped=true"
import script from "./qualityDetail.vue?vue&type=script&lang=js"
export * from "./qualityDetail.vue?vue&type=script&lang=js"
import style0 from "./qualityDetail.vue?vue&type=style&index=0&id=67271583&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67271583",
  null
  
)

export default component.exports